export default __webpack_public_path__ + "static/media/amparo-note.372e5879.webp";